/**
 * Banner 3000 — copy of Banner 1's field/metadata config. The widget itself is a
 * copy of Banner 1 with a shorter desktop height, so the CMS contract is identical.
 */
export const BANNER_3000_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    pre_title: "University",
    title_1: "Master of Business Administration",
    title_2: "Transform Your Career",
    cta_name: "Apply Now",
    priority: 1,
    status: true,
    mobile_bg_image: "",
    desktop_bg_image: "",
    alt_image: "Banner background",
    university_tag_text_color: "#FFFFFF",
    university_tag_background_color: "#BE2330",
    heading_text_color: "#FFFFFF",
    button_color: "#BE2330",
    button_text: "Apply Now",
    button_text_color: "#FFFFFF",
    button_icon: "",
    button_icon_alt: "",
    gradient_angle: "254deg",
    gradient_start_color: "rgba(0, 0, 0, 0.00)",
    gradient_end_color: "rgba(10, 61, 91, 1)",
    mobile_gradient_angle: "0deg",
    mobile_gradient_start_color: "rgba(5, 33, 50, 0.80)",
    mobile_gradient_end_color: "rgba(5, 33, 50, 0.80)",
  },

  // Add DEFAULT_ROW_1 for learners
  DEFAULT_ROW_1: {
    id: "1",
    image: "",
    priority: 1,
    alt_image: "Learner"
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "slide_frequency",
      label: "Slide Frequency",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Slide Frequency (ms)",
      required: true,
      defaultValue: 5000,
    },
    {
      fieldName: "status",
      label: "Banner Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Banner",
      defaultValue: false,
    },
    {
      fieldName: "bleed_background_color",
      label: "Banner Background Color (desktop sides)",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    // Add learners fields
    {
      fieldName: "learners_description",
      label: "Learners Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter Learners Description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "learners_description_color",
      label: "Learners Description Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "learners_description_section_color",
      label: "Learners Description Section Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter section background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "learners_status",
      label: "Learners Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Learners",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Pre-Title",
      fieldName: "pre_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre-Title",
    },
    {
      header: "Title 1",
      fieldName: "title_1",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1",
    },
    {
      header: "Title 2",
      fieldName: "title_2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
    },
    // {
    //   header: "CTA Name",
    //   fieldName: "cta_name",
    //   value: "",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter CTA Name",
    // },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
    {
      header: "Mobile BG Image",
      fieldName: "mobile_bg_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter Mobile BG Image",
    },
    {
      header: "Desktop BG Image",
      fieldName: "desktop_bg_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter Desktop BG Image",
    },
    {
      header: "Alt Image",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Desktop Image",
    },
    {
      header: "University Tag Text Color",
      fieldName: "university_tag_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "University Tag Background Color",
      fieldName: "university_tag_background_color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #BE2330)",
      defaultValue: "#BE2330",
    },
    {
      header: "Heading Text Color",
      fieldName: "heading_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter heading text color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Button Color",
      fieldName: "button_color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button background color (e.g., #BE2330)",
      defaultValue: "#BE2330",
    },
    {
      header: "Button Text",
      fieldName: "button_text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text",
      defaultValue: "Apply Now",
    },
    {
      header: "Button Text Color",
      fieldName: "button_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Button Icon",
      fieldName: "button_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon",
      defaultValue: "",
    },
    {
      header: "Button Icon Alt Text",
      fieldName: "button_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button icon alt text",
      defaultValue: "",
    },
    {
      header: "Gradient Angle",
      fieldName: "gradient_angle",
      value: "254deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 254deg, to right, 90deg)",
      defaultValue: "254deg",
    },
    {
      header: "Gradient Start Color",
      fieldName: "gradient_start_color",
      value: "rgba(0, 0, 0, 0.00)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(0, 0, 0, 0.00)",
      defaultValue: "rgba(0, 0, 0, 0.00)",
    },
    {
      header: "Gradient End Color",
      fieldName: "gradient_end_color",
      value: "rgba(10, 61, 91, 1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(10, 61, 91, 1)",
      defaultValue: "rgba(10, 61, 91, 1)",
    },
    {
      header: "Mobile Gradient Angle",
      fieldName: "mobile_gradient_angle",
      value: "0deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient angle (e.g., 0deg, 180deg)",
      defaultValue: "0deg",
    },
    {
      header: "Mobile Gradient Start Color",
      fieldName: "mobile_gradient_start_color",
      value: "rgba(5, 33, 50, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(5, 33, 50, 0.80)",
      defaultValue: "rgba(5, 33, 50, 0.80)",
    },
    {
      header: "Mobile Gradient End Color",
      fieldName: "mobile_gradient_end_color",
      value: "rgba(5, 33, 50, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(5, 33, 50, 0.80)",
      defaultValue: "rgba(5, 33, 50, 0.80)",
    },
  ],

  // Add METADATA_FIELDS_1 for learners
  METADATA_FIELDS_1: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter Learner Image",
      required: true,
    },
    {
      header: "Alt Image",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image",
      required: true,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};
  